/**API File for adding window functions to open/close dialogs externally*/
import {
    as_memory,
    as_popupsMutuallyExclusive,
    as_requestPopupOpen, MemoItem,
    setMemoPopupVisibility,
    setRequestPopupVisibility
} from "./app";
import {resetPopup, setInitialConfig} from "../js-app/util/state-util";
import {as_curStepData, StepData} from "../js-app/state";
import {ConnectedState, getConnectedValue, updateConnectedValue} from "./ConnectedStore";
import {addToMemoList, removeFromMemoList} from "./memo-list";
import Atom from "shlibs/dist/Atom";

export function initAPI(){
    console.log(`API INITialized`);
    window['rppApi'] = {
        setRequestPopupVisibility,
        setMemoPopupVisibility,
        resetPopup,
        setInitialConfig,
        onRequestPopupOpen:(callback:()=>void) => {
            as_requestPopupOpen.subscribeIf(callback,(nv)=>nv===true,'after')
        },
        onRequestPopupClose:(callback:()=>void) => {
            as_requestPopupOpen.subscribe((newVal)=>{
                if(newVal === false) callback();
            })
        },
        disableRequestAndMemoMutualExclusion:()=>{
            as_popupsMutuallyExclusive.set(false)
        },
        onMemoryItemsChange:(callback:(num:number)=>void)=>{
            as_memory.subscribe((newVal)=>callback(newVal.length))
            return as_memory.get().length;
        },
        stepBackInRequestForm:():boolean=>{
            const curStepData:StepData =  getConnectedValue<StepData>(as_curStepData);
            
            if(curStepData?.dispalyedStep <= 0) return false;
            updateConnectedValue(as_curStepData,{...curStepData,dispalyedStep:curStepData.dispalyedStep-1});
            return true;
        },
        memoList:as_memory,
        isInMemory:(wpid?:number, bookingid?:number) => {
            var existingElement = as_memory.get().find((e)=>{
                if(wpid && e.wpID == wpid) return true;
                if(bookingid && e.bookingID == bookingid) return true;
                return false;
            });
            
            return !!existingElement;
        },
        modifyMemoList:(wpid?:number, bookingid?:number,action:'add'|'remove'|'toggle' = 'toggle') => {
            var addEl:MemoItem = {bookingID:bookingid, wpID:wpid};
            if(action == 'add') addToMemoList(addEl);
            else if(action == 'remove') removeFromMemoList(addEl);
            else if(action == 'toggle') {
                var existingElement = as_memory.get().find((e)=>{
                    if(wpid && e.wpID == wpid) return true;
                    if(bookingid && e.bookingID == bookingid) return true;
                    return false;
                });
                if(existingElement) removeFromMemoList(addEl);
                else addToMemoList(addEl);
            }
            
        }
    }
}
